import React, { useState, useMemo, useEffect, useContext } from "react";
import { useNavigate ,useLocation} from "react-router-dom";
import DataTable from "./../../../../Layout/Table/TableLayoutOpp";
import { FaEdit,FaDownload, FaTrash, FaEye, FaUserPlus, FaComment, FaCopy, FaCalendarAlt, FaTimes } from "react-icons/fa";
import { Button, Row, Col, Modal, Form } from "react-bootstrap";
import Navbar from "../../../../Shared/Sales-ExecutiveNavbar/Navbar";
import { FaSave } from 'react-icons/fa';
import "./ViewLeads.css";
import axios from 'axios';
import { baseURL } from "../../../../Apiservices/Api";
import { io } from 'socket.io-client';
import { AuthContext } from '../../../../AuthContext/AuthContext';
import { webhookUrl } from "../../../../Apiservices/Api";
import { FontSizeContext } from "../../../../Shared/Font/FontContext";
import * as XLSX from 'xlsx';
import { useQuery } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';
import { adminMail } from '../../../../Apiservices/Api';

import CommentsModalpopemployee from '../../../Admin/Leads/ViewLeads/CommentsModalPop/CommentsModalpopemployee'; // ADD THIS IMPORT
import Loader from "../../../../Loader/Loader";


const ViewLeads = () => {
  const { authToken, userId ,userName} = useContext(AuthContext);
const queryClient = useQueryClient();

  const {
  data = [],
  isLoading,
  isError,
  error,
} = useQuery({
  queryKey: ['leads', userId], // 🔥 include userId
   refetchInterval: 3000, // every 30 sec
  queryFn: async () => {
    if (!userId) return [];

    const response = await fetch(`${baseURL}/api/addleads/statuslead`);
    const json = await response.json();

    const list = Array.isArray(json.data) ? json.data : [];

    return list.filter(e => e.assignedSalesId == userId);
  },
  enabled: !!userId, // 🔥 only run when userId exists
});

  const [message, setMessage] = useState('');
  const [isConnected, setIsConnected] = useState(false);
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  // const [data, setData] = useState([]);
    const location = useLocation();
  // Add this state with your other state declarations
const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
const [showCommentModal, setShowCommentModal] = useState(false);
const [selectedLeadForComment, setSelectedLeadForComment] = useState(null);
  const [searchTerm, setSearchTerm] = useState(localStorage.getItem("searchTerm-1") || "");
  const [filterStatus, setFilterStatus] = useState(localStorage.getItem("filterStatus-1") || "");
  const [filterDestination, setFilterDestination] = useState(localStorage.getItem("destination-1") || "");
  const [filterOppStatus1, setFilterOppStatus1] = useState(localStorage.getItem("opp1-1") || "Open");
  const [filterOppStatus2, setFilterOppStatus2] = useState(localStorage.getItem("opp2-1") || "");
  // 
  const [showDateRange, setShowDateRange] = useState(
      localStorage.getItem("showDateRange-1") === "true"
    );
  const [filterStartDate, setFilterStartDate] = useState(localStorage.getItem("startdate-1") || "");
  const [filterEndDate, setFilterEndDate] = useState(localStorage.getItem("enddate-1") || "");
  const [appliedFilterStartDate, setAppliedFilterStartDate] = useState(localStorage.getItem("appliedstart-1") || "");
  const [appliedFilterEndDate, setAppliedFilterEndDate] = useState(localStorage.getItem("appliesend-1") || "");

   // Save state to localStorage when values change
      useEffect(() => {
        localStorage.setItem("showDateRange-1", showDateRange);
      }, [showDateRange]);



  
  

  const generateWhatsAppLink = (phoneNumber) => {
    return `https://wa.me/${phoneNumber}`;
  };


  
useEffect(() => {
  const params = new URLSearchParams(location.search);
  const pageFromUrl = parseInt(params.get("page"));

  if (!isNaN(pageFromUrl)) {
    setPageIndex(pageFromUrl - 1); 
  }
}, [location.search]);


  const handleEdit = (leadId,currentPage) => {
    const params = new URLSearchParams(location.search);
    const pageSize = params.get('pageSize') || '20';
    navigate(`/edit-lead/${leadId}?page=${currentPage + 1}&pageSize=${pageSize}`, {
      state: { leadid: leadId },
    });
  };

  const handleAddUser = (lead,currentPage) => {
    const params = new URLSearchParams(location.search);
    const pageSize = params.get('pageSize') || '20';
    navigate(`/create-customer-opportunity/${lead.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`);
  };

  const handleAddLead = () => {
    navigate('/add-lead');
  };

  const handleViewLeads = (lead,currentPage) => {
    const params = new URLSearchParams(location.search);
    const pageSize = params.get('pageSize') || '20';
    navigate(`/view-lead/${lead.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`, {
      state: { leadid: lead.leadid },
    });
  };





const handleCommentClick = (lead) => {
  setSelectedLeadForComment(lead);
  setShowCommentModal(true);
};



  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setMessage("Copied to clipboard!");
      setTimeout(() => setMessage(""), 1000);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };
  const [dropdownOptions, setDropdownOptions] = useState({
    primary: [],
    secondary: {}
  });
  
  useEffect(() => {
    fetchLeadStatus();
  }, []);
  
  const fetchLeadStatus = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/lead-status`);
      setDropdownOptions({
        primary: res.data.primary || [],
        secondary: res.data.secondary || {}
      });
    } catch (error) {
      console.error("Error fetching lead status:", error);
    }
  };

  // const dropdownOptions = {
  //   primary: ["New", "No Response", "Duplicate", "False Lead", "Junk", "Plan Cancelled"],
  //   secondary: {
  //     New: ["Yet to Contact", "Not picking up call", "Asked to call later"],
  //     "No Response": [],
  //     Duplicate: [],
  //     "False Lead": [],
  //     Junk: ["Plan Cancelled", "Plan Delayed", "Already Booked", "Others"],
  //     "Plan Cancelled": [],
  //   },
  // };

  // const handlePrimaryStatusChange = (value, rowId) => {
  //   setData((prevData) =>
  //     prevData.map((row) =>
  //       row.leadid === rowId
  //         ? {
  //           ...row,
  //           primaryStatus: value,
  //           secondaryStatus: "",
  //         }
  //         : row
  //     )
  //   );
  //   updateLeadStatus(rowId, value, "");
  // };

  // const handleSecondaryStatusChange = (value, rowId) => {
  //   setData((prevData) =>
  //     prevData.map((row) =>
  //       row.leadid === rowId ? { ...row, secondaryStatus: value } : row
  //     )
  //   );
  //   const lead = data.find((lead) => lead.leadid === rowId);
  //   updateLeadStatus(rowId, lead?.primaryStatus || "", value);
  // };
const updateLeadStatus = async (leadId, primaryStatus, secondaryStatus) => {
  // ✅ Optimistic — instant UI update
  queryClient.setQueryData(['leads', userId], (old = []) =>
    old.map((r) =>
      r.leadid === leadId
        ? { ...r, primaryStatus, secondaryStatus: secondaryStatus || '' }
        : r
    )
  );
 
  try {
    const response = await axios.put(`${baseURL}/api/leads/status/${leadId}`, {
      primaryStatus,
      secondaryStatus: secondaryStatus || '',
    });
    if (response.status === 200) {
      setMessage('Status updated successfully.');
      setTimeout(() => setMessage(''), 3000);
      return true;
    }
  } catch {
    queryClient.invalidateQueries(['leads', userId]); // ✅ rollback
    setMessage('Update failed, reverting...');
    setTimeout(() => setMessage(''), 3000);
  }
  return false;
};
  const initializeSocket = () => {
    const socket = io(`${webhookUrl}`, {
      transports: ['websocket'],
    });
    socket.on('connect', () => {
      console.log('Connected to WebSocket');
      setIsConnected(true);
    });
    socket.on('connect_error', (err) => {
      console.error('Connection error:', err);
      setIsConnected(false);
    });
    socket.on('newEnquiry', (newEnquiry) => {
  console.log('Received new enquiry:', newEnquiry);

  queryClient.setQueryData(['leads', userId], (oldData = []) => {
    // Prevent duplicates
    const exists = oldData.some(
      (lead) => lead.leadid === newEnquiry.leadid
    );

    if (exists) return oldData;

    return [...oldData, newEnquiry];
  });
});

    socket.on('disconnect', () => {
      console.log('Disconnected from WebSocket');
      setIsConnected(false);
    });

    return socket;
  };

  useEffect(() => {
    const socket = initializeSocket();
    return () => {
      console.log('Component unmounted. Disconnecting WebSocket...');
      socket.disconnect();
    };
  }, []);

  // useEffect(() => {
  //   const fetchEnquiries = async () => {
  //     // console.log("userid=",userId) 
  //     if (!userId) {
  //       // console.log("not exist userid=",userId) 
  //       return;
  //     }

  //     try {
  //       const response = await fetch(`${webhookUrl}/api/enquiries`, {
  //         headers: {
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       });
  //       const data = await response.json();
  //       const filteredData = data.filter(
  //         (enquiry) => enquiry.assignedSalesId == userId && enquiry.status == 'lead'
  //       );
  //       console.log("filterd data=", filteredData.length);
  //       setData(filteredData);
  //     } catch (error) {
  //       console.error('Error fetching enquiries:', error);
  //     }
  //   };

  //   fetchEnquiries();
  // }, [userId, authToken]); 

  // useEffect(() => {
  //   const fetchEnquiries = async () => {
  //      setLoading(true); // Start loading
  //     try {
  //       const response = await fetch(`${baseURL}/api/addleads/statuslead`);
  //       const json = await response.json();
  
  //       // check array exists
  //       const list = Array.isArray(json.data) ? json.data : [];
  
  //       const filtered = list.filter(e => e.assignedSalesId == userId);
  
  //       setData(filtered);
  
  //     } catch (error) {
  //       console.error('Error fetching enquiries:', error);
  //     }finally {
  //   setLoading(false); // Stop loading
  // }
  //   };
  
  //   fetchEnquiries();
  // }, [userId, authToken]);

  useEffect(() => {
    localStorage.setItem("searchTerm-1", searchTerm);
    localStorage.setItem("filterStatus-1", filterStatus);
    localStorage.setItem("destination-1", filterDestination);
    localStorage.setItem("opp1-1", filterOppStatus1);
    localStorage.setItem("opp2-1", filterOppStatus2);
   
 
    localStorage.setItem("startdate-1", filterStartDate);
    localStorage.setItem("enddate-1", filterEndDate);
    localStorage.setItem("appliedstart-1", appliedFilterStartDate);
    localStorage.setItem("appliesend-1", appliedFilterEndDate);
  }, [
    searchTerm, filterStatus, filterDestination, filterOppStatus1, filterOppStatus2,
   filterStartDate, filterEndDate,
    appliedFilterStartDate, appliedFilterEndDate
  ]);


  

  const clearFilters = () => {
    setSearchTerm("");
    setFilterStatus("");
    setFilterDestination("");
    setFilterOppStatus1("Open");
    setFilterOppStatus2("");
    
   
    setFilterStartDate("");
    setFilterEndDate("");
    setAppliedFilterStartDate("");
    setAppliedFilterEndDate("");
          setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');        
                        url.searchParams.set('pageSize', '20'); 
      url.searchParams.delete('pageSize');
                    window.history.pushState({}, '', url);
    localStorage.removeItem("potentialLeadsFilters");
  };


  const filteredData = useMemo(() => {
    return data.filter((item) => {
      const matchesSearchTerm =
        !searchTerm ||
        Object.values(item).some(
          (val) =>
            val &&
            val.toString().toLowerCase().includes(searchTerm.toLowerCase())
        );

        const actualPrimaryStatus = item.primaryStatus ? item.primaryStatus.toLowerCase() : "Open";
        const matchesPrimaryStatus =
          !filterOppStatus1 || actualPrimaryStatus === filterOppStatus1.toLowerCase();
      const matchesSecondaryStatus =
        !filterOppStatus2 || (item.secondaryStatus && item.secondaryStatus.toLowerCase() === filterOppStatus2.toLowerCase());
      const matchesDestination = !filterDestination || (item.destination && item.destination.toLowerCase() == filterDestination.toLowerCase());
      const matchesDateRange = (() => {
        if (appliedFilterStartDate && appliedFilterEndDate) {
          const start = new Date(appliedFilterStartDate);
          const end = new Date(appliedFilterEndDate).setHours(23, 59, 59, 999);
          const createdAt = new Date(item.created_at);
          return createdAt >= start && createdAt <= end;
        }
        return true;
      })();

      return matchesSearchTerm && matchesPrimaryStatus && matchesDestination && matchesSecondaryStatus && matchesDateRange;
    });
  }, [searchTerm, filterOppStatus1, filterOppStatus2, filterDestination, appliedFilterStartDate, appliedFilterEndDate, data]);

  const uniqueDestinations = useMemo(() => {
    // Filter out empty destinations and normalize valid ones
    const normalizedDestinations = data
      .map(item => item.destination?.trim()) // Trim spaces and handle potential undefined/null values
      .filter(dest => dest) // Remove empty values
      .map(dest => dest.toLowerCase()); // Convert to lowercase for uniqueness

    // Get unique values and format them
    return [...new Set(normalizedDestinations)]
      .map(dest => dest.charAt(0).toUpperCase() + dest.slice(1)); // Capitalize first letter
  }, [data]);

  const columns = useMemo(
    () => [
      {
        Header: "LeadId",
        accessor: "leadid",
      },
      {
        Header: "Name",
        accessor: "name",             
           Cell: ({ row }) => {
          const currentPage = pageIndex; 
              const params = new URLSearchParams(location.search);
    const pageSize = params.get('pageSize') || '20';
          return (
          <div>
            <div
              style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
              onClick={() => handleViewLeads(row.original,currentPage,pageIndex) }
            >
              {row.original.name}
            </div>
          </div>
        )
      }
      },
      {
        Header: "Mobile",
        accessor: "phone_number",
        Cell: ({ row }) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <a
              href={`https://wa.me/${row.original.phone_number}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "blue", cursor: "pointer" }}
              title="Chat on WhatsApp"
            >
              {row.original.phone_number}
            </a>
            <FaCopy
              style={{ marginLeft: "8px", cursor: "pointer", color: "#ff9966" }}
              onClick={() => copyToClipboard(row.original.phone_number)}
              title="Copy Phone Number"
            />
          </div>
        ),
      },
      {
        Header: "Email",
        accessor: "email",
        Cell: ({ row }) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              maxWidth: "200px",
            }}
          >
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100px",
              }}
              title={row.original.email}
            >
              {row.original.email}
            </div>
            <FaCopy
              style={{ cursor: "pointer", color: "#ff9966" }}
              onClick={() => copyToClipboard(row.original.email)}
              title="Copy Email"
            />
          </div>
        ),
      },
      {
        Header: "Destination",
        accessor: "destination",
        Cell: ({ row }) => (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100px",
            }}
            title={row.original.destination}
          >
            {row.original.destination}
          </div>
        ),
      },
      {
        Header: "Lead Status",
        Cell: ({ row }) => {
          const { fontSize } = useContext(FontSizeContext);
          const { primaryStatus, secondaryStatus, leadid } = row.original;

          // ✅ FIX: Default to "New" when primaryStatus is null/undefined/empty
          const defaultPrimary = primaryStatus || "Open";

          const [localPrimary, setLocalPrimary] = useState(defaultPrimary);
          const [localSecondary, setLocalSecondary] = useState(secondaryStatus || "");
          const [isDirty, setIsDirty] = useState(false);
      
          // ✅ FIX: Sync with defaultPrimary (not raw primaryStatus) so "New" persists on refetch/navigation
          useEffect(() => {
            setLocalPrimary(primaryStatus || "Open");
            setLocalSecondary(secondaryStatus || "");
            setIsDirty(false);
          }, [primaryStatus, secondaryStatus]);
      
          const secondaryOptions = localPrimary ? (dropdownOptions.secondary[localPrimary] || []) : [];
          const isSecondaryDisabled = !localPrimary || secondaryOptions.length === 0;
      
          const handlePrimaryChange = (e) => {
            const newPrimary = e.target.value;
            setLocalPrimary(newPrimary);
            setLocalSecondary("");
            setIsDirty(true);
          };
      
          const handleSecondaryChange = (e) => {
            setLocalSecondary(e.target.value);
            setIsDirty(true);
          };

          const canSave =
            localPrimary && 
            (secondaryOptions.length === 0 || (secondaryOptions.length > 0 && localSecondary));
      
          const handleSave = async () => {
            try {
              await updateLeadStatus(leadid, localPrimary, localSecondary);
              queryClient.setQueryData(['leads', userId], (oldData = []) =>
                oldData.map((r) =>
                  r.leadid === leadid
                    ? { ...r, primaryStatus: localPrimary, secondaryStatus: localSecondary }
                    : r
                )
              );
              setIsDirty(false);
            } catch (error) {
              console.error('Error saving status:', error);
            }
          };
      
          return (
            <div className="d-flex align-items-center" style={{ fontSize: fontSize }}>
              <select
                value={localPrimary}
                onChange={handlePrimaryChange}
                className="form-select me-2"
                style={{ fontSize: fontSize }}
              >
                <option value="">Select Primary</option>
                {dropdownOptions.primary.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
      
              <select
                value={localSecondary}
                onChange={handleSecondaryChange}
                className="form-select me-2"
                style={{ fontSize: fontSize }}
                disabled={isSecondaryDisabled}
              >
                <option value="">Select Secondary</option>
                {secondaryOptions.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
      
              {isDirty && (
                <FaSave
                  onClick={canSave ? handleSave : undefined}
                  title={canSave ? "Save changes" : "Select secondary status to enable"}
                  style={{
                    color: canSave ? "#ff9966" : "#ccc",
                    cursor: canSave ? "pointer" : "not-allowed",
                    fontSize: "32px",
                  }}
                />
              )}
            </div>
          );
        },
      },
      {
        Header: "Source",
        accessor: "sources",
      },
      {
        Header: () => <div style={{ whiteSpace: "nowrap" }}>Customer Status</div>,
        accessor: "customer_status",
      },
      {
        Header: "Actions",
        Cell: ({ row }) => {
          const currentPage = pageIndex;
          const params = new URLSearchParams(location.search);
          const pageSize = params.get('pageSize') || '20';
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaEdit
                style={{ color: "#ff9966", cursor: "pointer" }}
                onClick={() => handleEdit(row.original.leadid, currentPage, pageSize)}
              />
              <FaEye
                style={{ color: "#ff9966", cursor: "pointer" }}
                onClick={() => handleViewLeads(row.original, currentPage, pageSize)}
              />
              <FaUserPlus
                style={{ color: "#ff9966", cursor: "pointer" }}
                onClick={() => handleAddUser(row.original, currentPage, pageSize)}
              />
              <FaComment
                style={{ color: "#ff9966", cursor: "pointer" }}
                onClick={() => handleCommentClick(row.original)}
              />
            </div>
          );
        } 
      }
    ],
    [data, pageIndex, location, dropdownOptions]  // ✅ added dropdownOptions as dependency
  );

  return (
    <div className="salesViewLeadsContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`salesViewLeads ${collapsed ? "collapsed" : ""}`}>
        <div className="ViewLead-container mb-5">
          <div className="ViewLead-table-container">
            <Row className="mb-3">
              <Col className="d-flex justify-content-between align-items-center">
                <h3>Lead Details</h3>
                {message && <div className="alert alert-info">{message}</div>}
                <Button onClick={handleAddLead}>Add Leads</Button>
              </Col>
            </Row>
            <Row className="mb-3 align-items-center">
              <Col md={6} className="d-flex align-items-center gap-2">
                <input
                  type="text"
                  className="form-control" 
                  placeholder="Free Text Search..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    localStorage.setItem("searchTerm-1", e.target.value);
                    setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);
                  }}
                />
                {showDateRange ? (
                  <FaTimes
                    onClick={() => {
                      setShowDateRange(false);
                      localStorage.setItem("showDateRange-1", "false");
                      setFilterStartDate("");
                      setFilterEndDate("");
                      setAppliedFilterStartDate("");
                      setAppliedFilterEndDate("");
                      localStorage.removeItem("filterStartDate-1");
                      localStorage.removeItem("filterEndDate-1");
                      localStorage.removeItem("appliedstart-1");
                      localStorage.removeItem("appliesend-1");
                    }}
                    style={{ cursor: "pointer", fontSize: "1.5rem" }}
                    title="Hide Date Range"
                  />
                ) : (
                  <FaCalendarAlt
                    onClick={() => {
                      setShowDateRange(true);
                      localStorage.setItem("showDateRange-1", "true");
                    }}
                    style={{ cursor: "pointer", fontSize: "1.5rem" }}
                    title="Show Date Range"
                  />
                )}
                {showDateRange && (
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type="date"
                      className="form-control"
                      value={filterStartDate}
                      onChange={(e) => setFilterStartDate(e.target.value)}
                    />
                    <span>to</span>
                    <input
                      type="date"
                      className="form-control"
                      value={filterEndDate}
                      onChange={(e) => setFilterEndDate(e.target.value)}
                    />
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        setAppliedFilterStartDate(filterStartDate);
                        setAppliedFilterEndDate(filterEndDate);
                        setPageIndex(0);
                        const url = new URL(window.location);
                        url.searchParams.delete("page");
                        window.history.pushState({}, "", url);
                      }}
                    >
                      OK
                    </button>
                  </div>
                )}
              </Col>
              <Col md={6} className="d-flex justify-content-end">
                <button className="btn btn-secondary" onClick={clearFilters}>Clear Filters</button>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={3}>
                <select
                  className="form-select"
                  value={filterDestination}
                  onChange={(e) => {
                    setFilterDestination(e.target.value);
                    setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);
                  }}
                >
                  <option value="">Destinations</option>
                  {uniqueDestinations.map((dest) => (
                    <option key={dest} value={dest}>{dest}</option>
                  ))}
                </select>
              </Col>
              <Col md={3}>
                <select
                  className="form-select"
                  value={filterOppStatus1}
                  onChange={(e) => {
                    setFilterOppStatus1(e.target.value);
                    setFilterOppStatus2("");
                    setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);
                  }}
                >
                  <option value="">Primary Status</option>
                  {dropdownOptions.primary.map((status) => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              </Col>
              <Col md={3}>
                <select
                  className="form-select"
                  value={filterOppStatus2}
                  onChange={(e) => {
                    setFilterOppStatus2(e.target.value);
                    setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);
                  }}
                >
                  <option value="">Secondary Status</option>
                  {dropdownOptions.secondary[filterOppStatus1]?.map((status) => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              </Col>
            </Row>
              {/* Add loader */}
        {/* {isLoading ? (
          <div className="text-center p-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading leads...</p>
          </div>
        ) : filteredData.length === 0 ? (
          <div className="text-center p-5">
            <p>No leads available</p>
          </div>
        ) : ( */}
            {isLoading ? (
                       <Loader />
                     ) : data.length === 0 ? (
                                 <div className="text-center p-5">
                                   <p>No data available</p>
                                 </div>
                               ) : (
 <DataTable 
                columns={columns} 
                data={filteredData} 
                pageIndex={pageIndex}
                setPageIndex={setPageIndex}
              />
            )}
          </div>
        </div>
      </div>

      <CommentsModalpopemployee
        show={showCommentModal}
        onHide={() => {
          setShowCommentModal(false);
          setSelectedLeadForComment(null);
        }}
        selectedLead={selectedLeadForComment}
        userName={userName}
      />
    </div>
  );
};

export default ViewLeads;